import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

/**
 * 自動報價相關model
 */
export namespace AutoDrawModels {

    /**
     * Tim
     */
    export class Tim {
        [key: string]: any;

        id: number | null;
        project_id: number | null;
        number: string | null;
        tim_type: number | null;
        tim_model: string | null;
        length: number | null;
        width: number | null;
        thickness: number | null;
        thermal_coefficient: number | null;
        hardness: number | null;
        hardness_tolerance: number | null;
        hardness_tester: number | null;
        color: string | null;
        shape: number | null;
        adhesive: number | null;
        adhesive_type: string | null;
        adhesive_include_thickness: boolean | null;
        adhesive_thickness: number | null;
        frame_type: boolean | null;
        pulltab: boolean | null;
        pulltab_length: number | null;
        date: Date | null; 
        drawing_number: string | null;
        file_name: string | null;
        quantity: number | null;
        order_quantity: number | null;
        flat_length: number | null;
        flat_width: number | null;
        ship: number | null;
        trim_hole: number | null;
        slide_cut: number | null;
        layer: number | null;
        price: number | null;
        view_angle: number | null;
        moq: number | null;
        memo: string | null;
        created_at: string | null;
        updated_at: string | null;
        deleted_at: string | null;

        selected: boolean = false;
    
        constructor() {
            this.id = null;
            this.project_id = null;
            this.number = null;
            this.tim_type = null;
            this.tim_model = null;
            this.length = null;
            this.width = null;
            this.thickness = null;
            this.thermal_coefficient = null;
            this.hardness = null;
            this.hardness_tolerance = null;
            this.hardness_tester = null;
            this.color = null;
            this.shape = null;
            this.adhesive = null;
            this.adhesive_type = null;
            this.adhesive_include_thickness = null;
            this.adhesive_thickness = null;
            this.frame_type = null;
            this.pulltab = null;
            this.pulltab_length = null;
            this.date = null;
            this.drawing_number = null;
            this.file_name = null;
            this.quantity = null;
            this.order_quantity = null;
            this.flat_length = null;
            this.flat_width = null;
            this.ship = null;
            this.trim_hole = null;
            this.slide_cut = null;
            this.layer = null;
            this.price = null;
            this.view_angle = null;
            this.moq = null;
            this.memo = null;
            this.created_at = null;
            this.updated_at = null;
            this.deleted_at = null;
        }


        /**
         * 組成聯絡我們參數部分郵件html內容
         * @returns `string`
         */
        composeParamsContent(translate: TranslateService): string {
            const pulltab = this.pulltab ? `是` : '否';
            const pulltab_length_str = this.pulltab ? `${this.pulltab_length}x${this.width}` : '-';
            const hardness_tolerance_str = this.hardness_tolerance ? `±${this.hardness_tolerance}` : '-';
            const hardness_tester_str = this.hardness_tester ? translate.instant(`AUTO_DRAW.ENUM.HARDNESS_TESTER.${this.hardness_tester}`) : '-';
            const view_angle_str = this.view_angle ? translate.instant(`AUTO_DRAW.ENUM.VIEW_ANGLE.${this.view_angle}`) : '-';
            const result = `
                <ul>
                    <li>編號：${this.number}</li>
                    <li>TIM種類：${translate.instant(`AUTO_DRAW.ENUM.TIM_TYPE.${this.tim_type}`)}</li>
                    <li>TIM型號：${this.tim_model}</li>
                    <li>長：${this.length || '-'} mm</li>
                    <li>寬：${this.width || '-'} mm</li>
                    <li>厚：${this.thickness || '-'} mm</li>
                    <li>導熱係數：${this.thermal_coefficient || '-'} W/mk</li>
                    <li>硬度計：${hardness_tester_str}</li>
                    <li>硬度：${this.hardness || '-'}</li>
                    <li>硬度公差：${hardness_tolerance_str}</li>
                    <li>顏色：${this.color}</li>
                    <li>形狀：${translate.instant(`AUTO_DRAW.ENUM.SHAPE.${this.shape}`)}</li>
                    <li>背膠：${translate.instant(`AUTO_DRAW.ENUM.ADHESIVE.${this.adhesive}`)}</li>
                    <li>背膠型號：${this.adhesive_type || '-'}</li>
                    <li>手撕位：${pulltab}</li>
                    <li>手撕位x寬：${pulltab_length_str} mm</li>
                    <li>需求總量：${this.order_quantity || '-' }</li>
                    <li>圖紙日期：${moment(this.date).format('YYYY-MM-DD HH:mm:ss')}</li>
                    <li>檔名：${this.file_name || '-'}</li>
                    <li>圖號：${this.drawing_number || '-'}</li>
                    <li>單一工件中數量：${this.quantity || '-' }</li>
                    <li>視角：${view_angle_str}</li>
                    <li>備註：${this.memo || '-'}</li>
                </ul>
            `;
            return result;
        }
    }

    /**
     * 產品分類
     */
    export class Project {
        id: number | null;
        product_category: number | null;
        company_name: string | null;
        applicant_name: string | null;
        applicant_email: string | null;
        applicant_phone: string | null;
        applicant_nation: string | null;
        applicant_city: string | null;
        applicant_address: string | null;
        created_at: string | null;
        updated_at: string | null;
        deleted_at: string | null;
        tims: Tim[];
    
        constructor() {
            this.id = null;
            this.product_category = null;
            this.company_name = null;
            this.applicant_name = null;
            this.applicant_email = null;
            this.applicant_phone = null;
            this.applicant_nation = null;
            this.applicant_city = null;
            this.applicant_address = null;
            this.created_at = null;
            this.updated_at = null;
            this.deleted_at = null;
            this.tims = [];
        }

        /**
         * 組成聯絡我們郵件html內容
         * @param receiver `string` 收件人名稱
         * @param params `string` 參數 Html string
         * @returns `string` Html template string
         */
        composeMailContent(receiver: string, parmas: string): string {
            const submitTim = this.updated_at ? this.updated_at : this.created_at;
            const result = `
                <p>Dear ${receiver}</p>
                <p>客戶已於Asink官網使用自動繪圖並留下個人資訊</p>
                <p>客戶訊息如下：</p>
                <ul>
                    <li>客戶公司名稱：${this.company_name}</li>
                    <li>客戶姓名：${this.applicant_name}</li>
                    <li>Email：${this.applicant_email}</li>
                    <li>電話：${this.applicant_phone}</li>
                    <li>國家/地區：${this.applicant_nation}</li>
                    <li>城市：${this.applicant_city}</li>
                    <li>地址：${this.applicant_address}</li>
                    <li>提交時間：${moment(submitTim).format('YYYY-MM-DD HH:mm:ss')}</li>
                </ul>
                <p>客戶填寫參數如下</p>
                <div>
                    ${parmas}
                </div>
                <p>From IR 工程組系統自動發送</p>
            `;

            return result
        }
    }


    /**
     * 演算法參數
     */
    export class AlgoTim {
        [key: string]: any;
        constructor(
            public tim_id: number | null = null,
            public file_name: string | null = null,
            public number: string | null = null,
            public tim_type: number | null = null,
            public tim_model: string | null = null,
            public drawing_number: string | null = null,
            public ship: number | null = null,
            public thermal_coefficient: number | null = null,
            public length: number | null = null,
            public width: number | null = null,
            public thickness: number | null = null,
            public layer: number | null = null,
            public flat_length: number | null = null,
            public flat_width: number | null = null,
            public pulltab_length: number | null = null,
            public hardness: number | null = null,
            public hardness_tolerance: number | null = null,
            public hardness_tester: number | null = null,
            public color: string | null = null,
            public adhesive: number | null = null,
            public adhesive_type: string | null = null,
            public adhesive_include_thickness: boolean | null = null,
            public adhesive_thickness: number | null = null,
            public quantity: number | null = null,
            public view_angle: number | null = null,
            public company_name: string | null = null,
            public user_name: string | null = null,
            public date: string | null = null, 
            public trim_hole: number | null = null,
            public slide_cut: number | null = null,
            public is_return_report: boolean | null = null,
        ) {}
    }

    /**
     * 演算法完整參數
     */
    export class AlgoParams {
        constructor(
            public frame: number | null = null,
            public language: number | null = null,
            public request_from: number | null = null,
            public tims: AlgoTim[] = [],
        ) {}
    }

    /**
     * 自動繪圖演算法回傳值
     */
    export interface DrawResponse {
        inside_png: string;
        inside_dxf: string;
        inside_pdf: string;
        outside_png: string;
        outside_dxf: string;
        outside_pdf: string;
    }

    /**
     * 背膠型號規格
     */
    export interface Adhesive {
        model: any,
        thickness: number
    }
}